import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";
import type {
  ControlTarget,
  OkResponse,
  PanicCloseResponse,
  ToggleTradingRequest,
} from "../types";

export function useToggleTrading() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ToggleTradingRequest) => api.post<OkResponse>("/control/toggle-trading", body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["bot-instances"] });
      qc.invalidateQueries({ queryKey: ["overview"] });
    },
  });
}

// Fire-and-forget by design (see API_CONTRACT.md): this only queues the
// panic_close command, the bot's own poll loop executes it. The frontend's
// job ends at "ok:true, command_id" — it never shows a fake "closed" state
// from this response alone.
export function usePanicClose() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { bot_instance_id: ControlTarget }) =>
      api.post<PanicCloseResponse>("/control/panic-close", body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["overview"] });
      qc.invalidateQueries({ queryKey: ["trades"] });
    },
  });
}
